/*
 * Task notification toast
 * Purpose: Present task email queue outcomes consistently across task creation and editing entry points.
 * Implementation notes: A successful queue is distinct from downstream email delivery; failures retain the backend warning.
 * Recent changes: Added shared success and warning feedback for task notification queue requests.
 */

import { toast } from 'react-toastify';
import type { TaskNotificationOutcome } from '../../services/taskService';

export const showTaskNotificationOutcome = (notification: TaskNotificationOutcome): void => {
  if (notification.warning) {
    toast.warn(notification.warning);
    return;
  }

  if (notification.requested && notification.queued > 0) {
    toast.success(
      notification.queued === 1
        ? 'Email notification queued.'
        : `${notification.queued} email notifications queued.`
    );
  }
};
